'use strict';

const { h } = require('preact');

const OptionMessage = props => {
  if (!props) {
    return null;
  }
  const { classes, text } = props;

  let messageClasses = 'details';
  if (classes) {
    messageClasses += ` ${classes}`;
  }

  return h(
    'div',
    {
      class: messageClasses,
    },
    text
  );
};

module.exports = OptionMessage;
